export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";